import $http from './index.js'

export const postLogin = function(name,pass){
   return $http.post('/User/LoginUser',{account:name,password:pass})
}